'use client';

import React, { useState } from 'react';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';
import AuthBrandPanel from './AuthBrandPanel';

export default function AuthPageClient() {
  const [activeTab, setActiveTab] = useState<'login' | 'signup'>('login');

  return (
    <div className="min-h-screen flex" style={{ backgroundColor: 'var(--background)' }}>
      {/* Brand Panel — left half */}
      <AuthBrandPanel />

      {/* Auth Form — right half */}
      <div className="w-full lg:w-1/2 flex flex-col items-center justify-center px-6 py-12 lg:px-16">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="flex items-center gap-2.5 mb-8 lg:hidden justify-center">
            <div
              className="w-9 h-9 rounded-xl flex items-center justify-center"
              style={{ background: 'linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%)' }}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                <path d="M4 14V6a2 2 0 012-2h8a2 2 0 012 2v8l-4-2-4 2z" fill="white" opacity="0.9" />
                <path d="M10 4l1.5 3.5L15 8l-2.5 2.5.5 3.5L10 12l-3 2 .5-3.5L5 8l3.5-.5L10 4z" fill="#F59E0B" opacity="0.8" />
              </svg>
            </div>
            <span className="font-bold text-xl" style={{ color: 'var(--foreground)' }}>ExamReady</span>
          </div>

          {/* Tab Switcher */}
          <div
            className="flex p-1 rounded-xl mb-8"
            style={{ backgroundColor: 'var(--muted)' }}
          >
            <button
              onClick={() => setActiveTab('login')}
              className="flex-1 py-2.5 text-sm font-semibold rounded-lg transition-all duration-200"
              style={{
                backgroundColor: activeTab === 'login' ? 'var(--card)' : 'transparent',
                color: activeTab === 'login' ? 'var(--primary)' : 'var(--muted-foreground)',
                boxShadow: activeTab === 'login' ? '0 1px 3px rgba(79,70,229,0.1)' : undefined,
              }}
            >
              Sign In
            </button>
            <button
              onClick={() => setActiveTab('signup')}
              className="flex-1 py-2.5 text-sm font-semibold rounded-lg transition-all duration-200"
              style={{
                backgroundColor: activeTab === 'signup' ? 'var(--card)' : 'transparent',
                color: activeTab === 'signup' ? 'var(--primary)' : 'var(--muted-foreground)',
                boxShadow: activeTab === 'signup' ? '0 1px 3px rgba(79,70,229,0.1)' : undefined,
              }}
            >
              Create Account
            </button>
          </div>

          {/* Form */}
          <div className="animate-fade-in">
            {activeTab === 'login' ? (
              <LoginForm onSwitchToSignup={() => setActiveTab('signup')} />
            ) : (
              <SignUpForm onSwitchToLogin={() => setActiveTab('login')} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}